import React from "react";
import { Link } from "react-router-dom";


export default function NavbarForlogin(){
   const navbarStyle = {
   minHeight: '60px', // default height (can be overridden via media query in CSS)
    display: 'flex',
    alignItems: 'center',
    paddingTop: '5px',
    paddingBottom: '5px',
  };

  const navbarBrandStyle = {
    fontFamily: 'Garamond, serif',
    fontSize: '1.75rem',
    color: '#1d1e1e',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  };

  const logoStyle = {
   height: 'auto',
    width: 'clamp(50px, 6vw, 60px)', // responsive logo size
  
  };
  
return(
    <div>
    <nav className="navbar navbar-expand-lg navbar-light color border border-dark"  style={navbarStyle}>
      <Link to="/" className="navbar-brand ml-2" style={navbarBrandStyle}>
       <img src="/thedata/LogoTDRS.png" alt="Logo" style={logoStyle} />
       <h2 style={{ margin: 0, fontSize: 'inherit', fontFamily: 'Garamond, serif' }}>The Dry Fruit Shop</h2>
     </Link>
    
     
    </nav>
  </div>



)



}